import { render, staticRenderFns } from "./EditScholarshipModal.vue?vue&type=template&id=0b9a867b&scoped=true&"
import script from "./EditScholarshipModal.vue?vue&type=script&lang=js&"
export * from "./EditScholarshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a867b",
  null
  
)

export default component.exports